import React from 'react'
import App, { Container } from 'next/app'
import NextHead from 'next/head'
import { ApolloProvider } from '@apollo/client'
import withApollo from 'lib/withApollo'
import UIProvider from '@shiphero/ui/UIProvider'

import bugsnagClient from '../lib/bugsnag'
import Error from './_error'
const ErrorBoundary = bugsnagClient.getPlugin('react')

// Apollo 3 throws "Expected signal to be an instanceof AbortSignal" errors,
// apparently when prefetching apollo queries on the server side and when used with @auth0/auth0-react package
// This solution seems to work: https://github.com/apollographql/apollo-client/issues/6765#issuecomment-734469527
import fetch from 'node-fetch'
import { abortableFetch } from 'abortcontroller-polyfill/dist/cjs-ponyfill'
global.fetch = abortableFetch(fetch).fetch

/**
 * We overwite the default NextJS App component to
 * inject Apollo.
 * It wraps each page with ApolloProvider.
 */
class MyApp extends App {
  render() {
    const { Component, pageProps } = this.props
    const { apolloClient } = this.props // injected by withApollo.

    return (
      <UIProvider>
        <NextHead>
          <title>ShipHero</title>
        </NextHead>
        <Container>
          <ErrorBoundary FallbackComponent={Error}>
            <ApolloProvider client={apolloClient}>
              <Component {...pageProps} />
            </ApolloProvider>
          </ErrorBoundary>
        </Container>
      </UIProvider>
    )
  }
}

export default withApollo(MyApp)
